import { Link } from 'react-router-dom';
import { cn } from './cn';

type Props = { to: string; image?: string; title: string; location?: string; meta?: { label: string; value: string }[]; className?: string; style?: React.CSSProperties };

/**
 * Carte de réalisation: grande photo 16:9, titre, lieu.
 * Au survol, le bloc de texte se remplit d'orange foncé par le bas, le texte passe en blanc et glisse de 1,5 rem, et une flèche blanche apparaît.
 */
export default function ProjectCard({ to, image, title, location, meta = [], className, style }: Props) {
  const rows = [...(location ? [{ label: 'Lieu', value: location }] : []), ...meta];
  return (
    <Link to={to} style={style} className={cn('pc group block focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-charcoal', className)}>
      <div className="relative aspect-video overflow-hidden bg-secondary-200">
        {image && <img src={image} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]" />}
      </div>
      <div className="pc-text relative overflow-hidden pb-5 pr-6 pt-5 transition-colors duration-[250ms]">
        <div className="pc-shift transition-transform duration-[250ms] ease-in-out group-hover:translate-x-6 group-focus-visible:translate-x-6">
          <h3 className="pc-title pr-12 text-inherit font-sans text-[1.125rem] font-semibold normal-case leading-[1.4] tracking-normal text-black transition-colors duration-[250ms] group-hover:text-white group-focus-visible:text-white md:text-[1.25rem]" style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{title}</h3>
          {rows.length > 0 && (
            <dl className="mt-3 space-y-1">
              {rows.map((r) => (
                <div key={r.label} className="flex gap-2 text-xs uppercase tracking-[0.0625rem]">
                  <dt className="text-ink transition-colors duration-[250ms] group-hover:text-white group-focus-visible:text-white">{r.label}</dt>
                  <dd className="font-bold text-black transition-colors duration-[250ms] group-hover:text-white group-focus-visible:text-white">{r.value}</dd>
                </div>
              ))}
            </dl>
          )}
        </div>
        <svg aria-hidden viewBox="0 0 24 12" className="pc-arrow absolute right-6 top-6 hidden h-3 w-6 text-white group-hover:block group-focus-visible:block" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M0 6h23M18 1l5 5-5 5" /></svg>
      </div>
    </Link>
  );
}
